import { Injectable } from '@angular/core';
import { environment } from "../../environments/environment";
import { catchError, map } from "rxjs/operators";
import { Observable, throwError,  of as observableOf, } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class QuickbookService {
  constructor(private http: HttpClient) {}

  connectToQuickBookInit(): Observable<any> {
    return this.http
      .get<any>(environment.base_url + "/quickbooks/connect", {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  testConnection(): Observable<any> {
    let options: any = { observe: "response" };
    return this.http
      .post(environment.base_url + "/qbo/connection/test", {}, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  disconnectFromQuickBook(): Observable<any> {
    //qbo/config/disable
    let options: any = { observe: "response" };
    return this.http
      .post(environment.base_url + "/qbo/config/disable", {}, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  getQBConfig(): Observable<any> {
    return this.http
      .get<any>(environment.base_url + "/qbo/config", {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  getAccountSettingDropdownData(accountType: string): Observable<any> {
    //qbo/accounts?accountType=receivable
    return this.http
      .get<any>(
        environment.base_url + "/qbo/accounts?accountType=" + accountType,
        {
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  saveQBConfig(configData: any): Observable<any> {
    let options: any = { observe: "response" };
    return this.http
      .put(environment.base_url + "/qbo/config", configData, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  getSyncLogs(searchValue: any, apiParams: any, parameters: any) {
    let params = new HttpParams();

    if (searchValue !== "" && searchValue != null) {
      params = params.set("search", searchValue);
    }
    if (apiParams.status !== "" && apiParams.status !== null) {
      params = params.set("status", apiParams.status);
    }
    if (apiParams.module !== "" && apiParams.module !== null) {
      params = params.set("module", apiParams.module);
    }
    if (apiParams.startDate !== "" && apiParams.startDate !== null) {
      params = params.set("startDate", apiParams.startDate);
    }
    if (apiParams.endDate !== "" && apiParams.endDate !== null) {
      params = params.set("endDate", apiParams.endDate);
    }
    if (parameters)
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", parameters.pageSize)
        .set("columnName", parameters.sortModel[0].colId)
        .set("sortOrder", parameters.sortModel[0].sort);

    console.log(
      parameters,
      "parameters printing in quickbook service getSyncLogs",
    );
    return this.http
      .get(environment.base_url + "/qbo/logs", {
        observe: "response",
        params: params,
      })
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  verifyConnection(code: string, realmId: string, state: string) {
    //https://dev-api.fieldex.com/custella-0.0.1-SNAPSHOT/api/open/quickbooks/callback?code={codeVal}&realmId={realmId}&state={state}
    return this.http
      .get(
        environment.base_url +
          `/open/quickbooks/callback?code=${code}&realmId=${realmId}&state=${state}`,
        {
          responseType: "text",
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  retrySync(logId: string): Observable<any> {
    let options: any = { responseType: "text", observe: "response" };
    return this.http
      .get(environment.base_url + `/qbo/retry-sync?logId=${logId}`, options)
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  generateInvoice(body: any): Observable<any> {
    //quickbook/job-orders/generate-invoice?jobOrderId=1085
    let options: any = { observe: "response" };
    return this.http
      .post(
        environment.base_url +
          `/quickbook/job-orders/generate-invoice?jobOrderId=${body.jobOrderId}`,
        {},
        options,
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }

  disconnectConnection(realmId: string) {
    //https://dev-api.fieldex.com/custella-0.0.1-SNAPSHOT/api/open/quickbooks/callback?code={codeVal}&realmId={realmId}&state={state}
    return this.http
      .get(
        environment.base_url +
          `/open/qbo/config/disable?realmId=${realmId}`,
        {
          responseType: "text",
          observe: "response",
        },
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((error) => {
          return throwError(error);
        }),
      );
  }
}
